// src/Component/GlobalLoader.jsx
import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsLoading, selectLoadingMessage } from '../features/loading/loadingSlice';
import '../CSS/GlobalLoader.css';

const GlobalLoader = () => {
  const isLoading = useSelector(selectIsLoading);
  const loadingMessage = useSelector(selectLoadingMessage);

  if (!isLoading) return null;

  return (
    <>
      <div className="global-loader-backdrop" />

      <div className="global-loader-container">
        <div className="global-loader-content">
          {/* Infinity Loader */}
          {/* Infinity Loader (single continuous loop) */}
<div className="infinity-wrap" role="status" aria-label="Loading">
  <svg className="infinity-svg" viewBox="0 0 200 100" aria-hidden="true">
    {/* Track (optional faint background) */}
    <path
      className="infinity-track"
      d="M20,50 C20,20 60,20 100,50 C140,80 180,80 180,50 C180,20 140,20 100,50 C60,80 20,80 20,50"
      pathLength="100"
    />

    {/* Black half */}
    <path
      className="infinity-stroke infinity-black"
      d="M20,50 C20,20 60,20 100,50 C140,80 180,80 180,50 C180,20 140,20 100,50 C60,80 20,80 20,50"
      pathLength="100"
    />

    {/* Orange half (offset by 50 so it complements black) */}
    <path
      className="infinity-stroke infinity-orange"
      d="M20,50 C20,20 60,20 100,50 C140,80 180,80 180,50 C180,20 140,20 100,50 C60,80 20,80 20,50"
      pathLength="100"
    />
  </svg>
</div>


          <p className="global-loader-message">{loadingMessage}</p>
        </div>
      </div>
    </>
  );
};

export default GlobalLoader;

// Alternative: Simple overlay loader with GIF
export const SimpleGlobalLoader = () => {
  const isLoading = useSelector(selectIsLoading);
  const loadingMessage = useSelector(selectLoadingMessage);

  if (!isLoading) return null;

  return (
    <div className="simple-global-loader">
      <div className="simple-loader-overlay">
        <div className="simple-loader-content">
          <img 
            src="https://i.pinimg.com/originals/dc/cc/84/dccc846959dffafa30a836dfacf9bab9.gif" 
            alt="Loading..." 
            className="simple-loader-gif"
          />
          <span>{loadingMessage}</span>
        </div>
      </div>
    </div>
  );
};

// Hook for checking specific action loading state
export const useActionLoading = (actionType) => {
  return useSelector(state => 
    state.loading.loadingActions.includes(actionType)
  );
};